import apiHeader from '@/helpers/apiHeader';

const characteristicItemNameService = {
    list(params) {
        return apiHeader.get('dictionary/characteristic-item-names', { params });
    },
    listByItemName(params) {
        return apiHeader.get('dictionary/characteristic-item-names/search', { params });
    },
    create(params) {
        return apiHeader.post('dictionary/characteristic-item-names', params);
    },
    updateBulk(params) {
        return apiHeader.post('dictionary/characteristic-item-names/bulk-update', params);
    },
    updateById(id, params) {
        return apiHeader.put(`dictionary/characteristic-item-names/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`dictionary/characteristic-item-names/${id}`);
    },
    listCinValByCinCode(cinCode, params) {
        return apiHeader.get(`dictionary/characteristic-item-names/char-values/${cinCode}`, {params});
    },
    searchCinVal(params) {
        return apiHeader.get('dictionary/characteristic-item-names/char-values', {params});
    },
    createCinVal(params) {
        return apiHeader.post('dictionary/characteristic-item-names/char-values', params);
    },
    updateBulkCinVal(params) {
        return apiHeader.post('dictionary/characteristic-item-names/char-values/bulk-update', params);
    },
    replaceAbbrvCinVal(cinCode, params) {
        return apiHeader.post(`dictionary/characteristic-item-names/char-values/replace/${cinCode}`, params);
    },
    deleteCinVal(id) {
        return apiHeader.delete(`dictionary/characteristic-item-names/char-values/${id}`);
    },
}

export default characteristicItemNameService;
